import { render, staticRenderFns } from "./setoransimpanan.vue?vue&type=template&id=23d06192&scoped=true&"
import script from "./setoransimpanan.vue?vue&type=script&lang=js&"
export * from "./setoransimpanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d06192",
  null
  
)

export default component.exports